import { create } from 'zustand';
import * as api from '../services/api';

const DEFAULT_CREDENTIAL_TYPES = [
  'User ID', 'Customer ID', 'Corporate ID', 'Login ID',
  'Password', 'Login Password', 'Transaction Password',
  'PIN', 'Transaction PIN', 'MPIN'
];

export const useVendorStore = create((set, get) => ({
  vendors: [],
  selectedVendor: null,
  selectedBank: null,
  loading: true,
  customCredentialTypes: [],

  fetchVendors: async () => {
    try {
      const response = await api.getVendors();
      const vendors = response.data;
      const { selectedVendor, selectedBank } = get();

      let newSelectedVendor = null;
      if (selectedVendor) {
        newSelectedVendor = vendors.find(v => v.id === selectedVendor.id) || vendors[0] || null;
      } else if (vendors.length > 0) {
        newSelectedVendor = vendors[0];
      }

      let newSelectedBank = null;
      if (selectedBank && newSelectedVendor) {
        newSelectedBank = newSelectedVendor.banks?.find(b => b.id === selectedBank.id) || null;
      }

      set({ vendors, selectedVendor: newSelectedVendor, selectedBank: newSelectedBank, loading: false });
    } catch (err) {
      console.error('Failed to fetch vendors:', err.message);
      set({ loading: false });
    }
  },

  setSelectedVendor: (vendor) => set({ selectedVendor: vendor }),
  setSelectedBank: (bank) => set({ selectedBank: bank }),

  createVendor: async (data) => {
    const res = await api.createVendor(data);
    await get().fetchVendors();
    return res.data;
  },

  updateVendor: async (id, data) => {
    const res = await api.updateVendor(id, data);
    await get().fetchVendors();
    return res.data;
  },

  deleteVendor: async (id, pin) => {
    await api.deleteVendor(id, pin);
    const { selectedVendor } = get();
    if (selectedVendor?.id === id) set({ selectedVendor: null });
    await get().fetchVendors();
  },

  createBank: async (data) => {
    const res = await api.createBank(data);
    await get().fetchVendors();
    return res.data;
  },

  updateBank: async (vendorId, bankId, data) => {
    const res = await api.updateBank(vendorId, bankId, data);
    set({ selectedBank: res.data });
    await get().fetchVendors();
    return res.data;
  },

  deleteBank: async (vendorId, bankId, pin) => {
    await api.deleteBank(vendorId, bankId, pin);
    await get().fetchVendors();
  },

  addRecharge: async (vendorId, bankId, data) => {
    const res = await api.addRecharge(vendorId, bankId, data);
    set({ selectedBank: res.data });
    await get().fetchVendors();
    return res.data;
  },

  deleteRecharge: async (vendorId, bankId, rechargeId) => {
    const res = await api.deleteRecharge(vendorId, bankId, rechargeId);
    set({ selectedBank: res.data });
    await get().fetchVendors();
    return res.data;
  },

  // Credential types management
  fetchCredentialTypes: async () => {
    try {
      const res = await api.getCredentialTypes();
      set({ customCredentialTypes: res.data });
    } catch (err) { console.error('Failed to fetch credential types:', err.message); }
  },

  addCredentialType: async (name) => {
    await api.addCredentialType(name);
    await get().fetchCredentialTypes();
  },

  deleteCredentialType: async (name) => {
    await api.deleteCredentialType(name);
    await get().fetchCredentialTypes();
  },

  // Verification
  updateVerification: async (vendorId, bankId, checkName, data) => {
    const res = await api.updateVerification(vendorId, bankId, checkName, data);
    set({ selectedBank: res.data });
    await get().fetchVendors();
    return res.data;
  },

  // Partner assignment
  assignPartner: async (vendorId, bankId, partnerId) => {
    const res = await api.assignPartner(vendorId, bankId, partnerId);
    set({ selectedBank: res.data });
    await get().fetchVendors();
    return res.data;
  }
}));
